<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="add_ivr single_edit_add"  width="1100">
    <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div class="content">
      <div class="single_input">
        <div class="font_style_set"><span style="color: red">*</span>IVR名称:</div>
        <Input v-model="ivrName" placeholder="请输入IVR名称"/>
      </div>
      <div class="single_input">
        <div class="font_style_set">IVR类型:</div>
        <RadioGroup v-model="ivrType" type="button" placeholder="下级菜单">
          <Radio v-for="(option, index) in IVRTypeList" :label="option.id" :key="index">{{option.name}}</Radio>
        </RadioGroup>
      </div>
      <div class="single_input">
        <div class="font_style_set"><span v-show="ivrType=='1'" style="color: red">*</span>欢迎词类型:</div>
        <Select v-model="voiceType" style="width: 27%">
          <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Select v-model="voiceFile" style="width: 43%;padding-left: 2%;" :clearable="ivrType!='1'">
          <Option v-for="(option, index) in audioFileList" :value="option.voiceFileRoute" :key="index">{{option.voiceFileName}}</Option>
        </Select>
<!--        <Upload :action="uploadUrl"  v-if="voiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">-->
<!--          <img src="../../../assets/image/upload.png" title="欢迎词语音文件上传">-->
<!--        </Upload>-->
<!--        <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>-->
      </div>
      <div v-if="ivrType=='2'">
        <div class="single_input">
          <div class="font_style_set">开始转接时间(秒):</div>
          <Input v-model="startTransferTime" placeholder="开始转接时间"/>
          <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input">
          <div class="font_style_set">业务类型:</div>
          <Select v-model="transferBusinessType">
            <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              多个号码填写时以“,”作为间隔<br/>
              顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
              记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
              共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
              技能组：将呼入号码转接至所选技能组中<br/>
            </div>
          </Tooltip>
        </div>
        <div class="single_input" v-if="transferBusinessType!='9'">
          <div class="font_style_set"><span style="color: red">*</span>号码:</div>
          <Input v-model="transferTransNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
          <Tooltip class="tips_font" placement="top" content="填分机号,热线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="transferBusinessType=='9'">
          <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
          <Select v-model="transferTransNumber">
            <OptionGroup label="普通技能组">
              <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
            </OptionGroup>
            <OptionGroup label="AI技能组">
              <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
            </OptionGroup>
          </Select>
        </div>
      </div>
      <div v-else>
        <div class="single_input">
          <div class="font_style_set">可选设置:</div>
          <Checkbox v-model="highSet">高级设置</Checkbox>
          <Checkbox v-model="isCallExtension" v-if="highSet">允许拨打分机</Checkbox>
          <Checkbox v-model="isTimeoutBusiness" v-if="highSet">启用超时业务</Checkbox>
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">短欢迎词类型:</div>
          <Select v-model="shortVoiceType" style="width: 27%">
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Select v-model="shortVoiceFile" clearable style="width: 43%;padding-left: 2%;">
            <Option v-for="(option, index) in audioFileList" :value="option.voiceFileRoute" :key="index">{{option.voiceFileName}}</Option>
          </Select>
<!--          <Upload :action="uploadUrl" v-if="shortVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessShortVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">-->
<!--            <img src="../../../assets/image/upload.png" title="短欢迎词语音文件上传">-->
<!--          </Upload>-->
<!--          <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(shortVoiceFile)"></div>-->
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">无效提示音类型:</div>
          <Select v-model="invalidVoiceType" style="width: 27%">
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Select v-model="invalidVoiceFile" clearable style="width: 43%;padding-left: 2%;">
            <Option v-for="(option, index) in audioFileList" :value="option.voiceFileRoute" :key="index">{{option.voiceFileName}}</Option>
          </Select>
<!--          <Upload :action="uploadUrl" v-if="invalidVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessInvalidVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">-->
<!--            <img src="../../../assets/image/upload.png" title="无效提示音文件上传">-->
<!--          </Upload>-->
<!--          <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(invalidVoiceFile)"></div>-->
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">超过重复提示次数提示音类型:</div>
          <Select v-model="exceedVoiceType" style="width: 27%">
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Select v-model="exceedVoiceFile"  clearable style="width: 43%;padding-left: 2%;">
            <Option v-for="(option, index) in audioFileList" :value="option.voiceFileRoute" :key="index">{{option.voiceFileName}}</Option>
          </Select>
<!--          <Upload :action="uploadUrl" v-if="exceedVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessExceedVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">-->
<!--            <img src="../../../assets/image/upload.png" title="超次语音文件上传">-->
<!--          </Upload>-->
<!--          <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(exceedVoiceFile)"></div>-->
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">记忆功能:</div>
          <RadioGroup v-model="memoryType" type="button">
            <Radio v-for="(option, index) in memoryList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
        <div class="single_input" v-if="highSet && memoryType!='0'">
          <div class="font_style_set"><span style="color: red">*</span>记忆时间(分钟数):</div>
          <Input v-model="memoryDuration" placeholder="请输入记忆时间(分钟数)" @on-blur="checkPhoneNumber"/>
          <Tooltip class="tips_font" placement="top" content="1-50000"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && !isTimeoutBusiness">
          <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
          <Input v-model="promptInterval" placeholder="请输入重复提示间隔(秒)"/>
        </div>
        <div class="single_input" v-if="highSet && !isTimeoutBusiness">
          <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
          <Input v-model="promptCount" placeholder="请输入重复提示次数"/>
        </div>
        <div class="single_input" v-if="highSet && isTimeoutBusiness">
          <div class="font_style_set">超时时间(秒):</div>
          <Input v-model="timeout" @on-blur="checkPhoneNumber"/>
          <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && isTimeoutBusiness">
          <div class="font_style_set">业务类型:</div>
          <Select v-model="businessType">
            <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              多个号码填写时以“,”作为间隔<br/>
              顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
              记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
              共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
              技能组：将呼入号码转接至所选技能组中<br/>
            </div>
          </Tooltip>
        </div>
        <div class="single_input" v-if="highSet && isTimeoutBusiness && businessType!='9'">
          <div class="font_style_set"><span style="color: red">*</span>号码:</div>
          <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
          <Tooltip class="tips_font" placement="top" content="填分机号,热线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && isTimeoutBusiness && businessType=='9'">
          <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
          <Select v-model="transNumber">
            <OptionGroup label="普通技能组">
              <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
            </OptionGroup>
            <OptionGroup label="AI技能组">
              <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
            </OptionGroup>
          </Select>
        </div>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
  </Modal>
</template>

 <script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
    export default {
      name: "IVREditOrAdd",
      mixins:[publicFunClass],
      props:{
        showIVREditOrAdd:Boolean
      },
      components:{
        playMusicPop
      },
      data(){
        return{
          model:false,
          audioFileList:[],
          questionMark:require('../../../assets/image/homeAsk.png'),
          uploadUrl:this.baseURL+"common/upload.json?type=customizeMusic&companyNo="+localStorage.getItem("companyId"),
          contentHeight:{height:''},
          autoSize:true,
          showUploadList:false,
          showRecordFile:false,
          recordFile:'',
          format:['mp3','wav'],
          queueList:[],
          queueList2:[],
          ivrName:'',
          IVRTypeList:[{id:'1', name:"下级菜单"},{id:'2', name:"转接电话"}],
          ivrType:'1',
          highSet:false,
          isTimeoutBusiness:false,
          isCallExtension:false,
          welCodeList:[{id:'1', name:"语音文件"}],
          voiceType:'1',
          voiceFile:'',
          shortVoiceType:'1',
          shortVoiceFile:'',
          invalidVoiceType:'1',
          invalidVoiceFile:'',
          promptInterval:'3',
          promptCount:'3',
          exceedVoiceType:'1',
          exceedVoiceFile:'',
          memoryType:'0',
          memoryDuration:'',
          memoryList:[{id:'0', name:"关闭"},{id:'1', name:"呼出未接记录记忆"},{id:'2', name:"全部记录记忆"}],
          timeout:"20",
          businessList:[{id:'1', name:"顺振"},{id:'2', name:"记忆轮循"},{id:'3', name:"共振"},{id:'9', name:"技能组"}],
          businessType:'9',
          transNumber:'',
          startTransferTime:'0',
          transferBusinessType:'9',
          transferTransNumber:'',
          title:'添加语音导航',
          spinShow:false,
        }
      },
      methods:{
        checkPhoneNumber:function(event){
          let name=event.currentTarget.name;
          let value=event.currentTarget.value;
          let reg=/^[0-9]*$/;
          if(!reg.test(value)){
            this.$Modal.info({
              title:'提示',
              content:name+"只能输入数字"
            });
            event.currentTarget.value=event.currentTarget.value.replace(/[^\d]/g,'');
            return false;
          }
        },
        handleSuccessVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.voiceFile=file.response.obj.absolutePath;
        },
        handleSuccessShortVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.shortVoiceFile=file.response.obj.absolutePath;
        },
        handleSuccessInvalidVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.invalidVoiceFile=file.response.obj.absolutePath;
        },
        handleSuccessExceedVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.exceedVoiceFile=file.response.obj.absolutePath;
        },
        handleFail:function (error, file) {
          this.$Modal.info({
            title:'失败提示',
            content:file.response.msg
          });
        },
        //播放回调函数
        closeRecordfile:function(){
          this.showRecordFile=false;
        },
        //在线播放语音文件
        playVoiceFile:function (recordFile) {
          if(!recordFile){
            this.$Modal.info({
              title:'提示',
              content:"语音文件不存在"
            });
            return false;
          }
          this.showRecordFile=true;
          this.recordFile=this.baseImgURL+recordFile;
        },
        cancel:function () {
          this.$emit("closeIVREditOrAdd",false);
        },
        save:function () {
          let that=this;
          let businessType=this.businessType;
          let transNumber=this.transNumber;
          if(this.ivrType=='2'){
            businessType=this.transferBusinessType;
            transNumber=this.transferTransNumber;
          }
          if(this.memoryType!="0" && (this.memoryDuration>50000 || this.memoryDuration<1)){
            this.$Message.info("记忆时间必须在1到50000分钟之内");
            return false;
          }
          let time = '';
          if(this.ivrType=='1'){
            time = this.timeout;
          }
          if(this.ivrType=='2'){
            time = this.startTransferTime;
          }
          if(this.startTransferTime && (this.startTransferTime>60 || this.startTransferTime<0)){
            this.$Message.info("开始转接时间必须在0到60秒之内");
            return false;
          }
          this.spinShow = true;
          let param={
            journalType:"CTI配置=>IVR配置=>添加",
            menuId:"3_5-2-1",
            ivrName:this.ivrName,
            ivrType:this.ivrType,
            isTimeoutBusiness:this.isTimeoutBusiness?'1':'0',
            isCallExtension:this.isCallExtension?'1':'0',
            voiceType:this.voiceType,
            voiceFile:this.voiceFile,
            shortVoiceType:this.shortVoiceType,
            shortVoiceFile:this.shortVoiceFile,
            invalidVoiceType:this.invalidVoiceType,
            invalidVoiceFile:this.invalidVoiceFile,
            promptInterval:this.promptInterval,
            promptCount:this.promptCount,
            exceedVoiceType:this.exceedVoiceType,
            exceedVoiceFile:this.exceedVoiceFile,
            memoryType:this.memoryType,
            memoryDuration:this.memoryDuration,
            businessType:businessType,
            transNumber:transNumber,
            highSet:this.highSet?'1':'0',
            timeout:time
          };
          this.$http.post("ivrDesign/doSaveIvr.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.spinShow = false;
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Modal.info({
              title:'提示',
              content:that.title+"成功"
            });
            that.spinShow = false;
            that.$emit("closeIVREditOrAdd",true);
          })
        },
        searchFIle:function () {
          let param={
            journalType:"系统管理=>CTI配置=>语音文件查询",
            menuId:"null",
          };
          this.$http.post('voiceFile/toIndex.json',param).then(res=>{
            let response = res.data;
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false;
            }
            if(response.obj.list.content){
              this.audioFileList = response.obj.list.content;
            }
          });
        }
      },
      watch:{
        showIVREditOrAdd:function () {
          this.audioFileList=[];
          this.model=this.showIVREditOrAdd;
          this.ivrName='';
          this.ivrType='1';
          this.highSet=false;
          this.isTimeoutBusiness=false;
          this.isCallExtension=false;
          this.voiceType='1';
          this.voiceFile='';
          this.shortVoiceType='1';
          this.shortVoiceFile='';
          this.invalidVoiceType='1';
          this.invalidVoiceFile='';
          this.promptInterval='3';
          this.promptCount='3';
          this.exceedVoiceType='1';
          this.exceedVoiceFile='';
          this.memoryType='0';
          this.memoryDuration='';
          this.timeout="20";
          this.businessType='9';
          this.transNumber='';
          this.startTransferTime='0';
          this.transferBusinessType='9';
          this.transferTransNumber='';
          if(this.showIVREditOrAdd){
            this.getQueue("3");
            this.searchFIle();
          }
        }
      }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/IVREditOrAdd.vue